<img [alt]="title" class="recipeHeader-image" [src]="imageUrl" />
<div class="recipeHeader-content">
	<recipe-meal-times
		class="recipeHeader-mealTimes"
		*ngIf="mealTimes.length"
		[id]="id"
		[mealTimes]="mealTimes"
		[link]="true"
		[title]="title"
	></recipe-meal-times>
	<img class="recipeHeader-wapple-print" src="/logos/cd_logo_wapple.svg" alt="Countdown Wapple" />
	<h1 class="recipeHeader-title">{{ title }}</h1>
	<recipe-prep-summary
		class="recipeHeader-prepSummary"
		[ngClass]="{ 'prepSummary--leftAlign': isDesktop$ | async }"
		[prepDuration]="prepDuration"
		[cookDuration]="cookDuration"
		[servings]="servings"
		[id]="id"
	></recipe-prep-summary>
	<recipe-nutritional-info
		*ngIf="nutritionTags"
		[nutritionalTags]="nutritionTags"
	></recipe-nutritional-info>

	<p
		*ngIf="description"
		class="recipeHeader-description"
		#descriptionEl
		[ngClass]="{ 'recipeHeader-description--collapsed': collapsed }"
	>
		{{ description }}
	</p>

	<a (click)="expand()" *ngIf="collapsed && description" class="recipeHeader-readMore">Read more</a>

	<div class="recipeHeader-mealPlanningActions" *ngIf="isMealPlanningEnabled">
		<div *ngIf="isAddedToMealPlan" class="badge badge--green" i18n="@@recipeHeader-addedToMealPlanBadge" data-cy="addedToMealPlanBadge">
			<cdx-svg-icon name="tick-sign"	size="very-small" fill="green"></cdx-svg-icon>
			Added to meal plan
		</div>
		<button
			*ngIf="!isAddedToMealPlan"
			type="button"
			cdxButton
			[fillStyle]="isMealPlanningContext ? 'primary' : 'outline'"
			[fullWidth]="true"
			[startSlotActive]="true"
			startSlotSize="default"
			i18n="@@recipeHeader-addToMealPlanButton"
			data-cy="addToMealPlanButton"
			(click)="addToMealPlanClick()">
				<cdx-svg-icon name="soup-bowl-steaming" [fill]="isMealPlanningContext ? 'light' : 'green'" size="small" start></cdx-svg-icon>
				Add to meal plan
		</button>
		<button
			*ngIf="isAddedToMealPlan"
			type="button"
			cdxButton
			fillStyle="outline"
			[fullWidth]="true"
			[startSlotActive]="true"
			startSlotSize="default"
			i18n="@@recipeHeader-viewMealPlanButton"
			data-cy="viewMealPlanButton"
			(click)="viewMealPlanClick()"
		>
			<cdx-svg-icon name="soup-bowl-steaming" fill="green" size="small" start></cdx-svg-icon>
			View your meal plan
		</button>
	</div>

	<div class="recipeHeader-actions">
		<button
			cdxButton
			fillStyle="flat"
			[inline]="true"
			class="recipeHeader-saveRecipe"
			(click)="save.emit()"
			[buttonState]="saveButtonState"
			[startSlotActive]="true"
			startSlotSize="small"
			i18n="@@recipeHeader-saveButton"
		>
			<cdx-svg-icon [name]="saved ? 'heart-filled' : 'heart-default'" size="small" start fill="green"></cdx-svg-icon>
			{{ saved ? 'Saved' : 'Save' }}
		</button>

		<button
			*cdxEmbedded="'hide'"
			class="print-button"
			cdxButton
			fillStyle="flat"
			[inline]="true"
			startSlotSize="small"
			[startSlotActive]="true"
			(click)="print()"
			i18n="@@recipe-printText"
		>
			<cdx-svg-icon start name="print" size="small" fill="green"></cdx-svg-icon>
			Print
		</button>
		
		<button
			class="recipeHeader-share"
			cdxButton
			fillStyle="flat"
			[inline]="true"
			startSlotSize="small"
			[startSlotActive]="true"
			(click)="share()"
			i18n="@@recipe-shareText"
		>
			<cdx-svg-icon start name="share" size="small" fill="green"></cdx-svg-icon>
			Share
		</button>
	</div>
</div>
